import { Fragment } from 'react';
import { useFormikContext } from 'formik';

import { Button } from 'components/common/button/button';

import { useAppSelector } from 'redux/use-hooks';
import { selectAccountId } from 'redux/slices/account';
import { milliToNano, nanoSecondsToDate } from 'utils';
import { storageTabsOptions } from 'lib/constants';
import { FormValues } from 'types';

import {
  StyledTitle,
  StyledInputLabel,
  StyledInputValue,
  StyledInputWrapper,
  StyledAmount,
} from '../../increase-storage-view.style';

const ConfirmView = ({ activeTab, isLoading }) => {
  const accountId = useAppSelector(selectAccountId);
  const formik = useFormikContext<FormValues>();

  const [myStorageTab] = storageTabsOptions;
  const isMyStorageTab = activeTab.value === myStorageTab.value;

  return (
    <Fragment>
      <StyledTitle mb="88px">Confirm</StyledTitle>
      <StyledAmount>{formik.values.amount}</StyledAmount>
      <StyledInputWrapper mb="20px">
        <StyledInputLabel>Send to</StyledInputLabel>
        <StyledInputValue
          fontSize="xs"
          fontWeight="semiBold"
          color="input.text"
        >
          {isMyStorageTab ? accountId : formik.values.receiverId}
        </StyledInputValue>
      </StyledInputWrapper>
      <StyledInputWrapper mb="20px">
        <StyledInputLabel>From</StyledInputLabel>
        <StyledInputValue fontSize="xs" fontWeight="semiBold">
          {accountId}
        </StyledInputValue>
      </StyledInputWrapper>
      <StyledInputWrapper mb="20px">
        <StyledInputLabel>Date</StyledInputLabel>
        <StyledInputValue fontSize="xs" fontWeight="semiBold">
          {nanoSecondsToDate(milliToNano(Date.now()))}
        </StyledInputValue>
      </StyledInputWrapper>
      <Button type="submit" disabled={isLoading} loading={isLoading} fullwidth>
        {isLoading ? 'Sending' : 'Continue'}
      </Button>
    </Fragment>
  )
};

export default ConfirmView;
